// label 信息
export const labelDefault = {
  labelVisible: true,
  labelType: 'inner',
  labelColor: '#fff',
  labelOffset: 10
}

export const labelTypeOpts = [
  {
    value: 'inner',
    label: '内部标签'
  },
  {
    value: 'outer',
    label: '外部标签'
  },
  {
    value: 'spider',
    label: '蜘蛛布局标签'
  }
]

export const labelConfig = [
  {
    info: {
      title: '数据标签（Label）',
      icon: 'icon-setting'
    },
    fields: [
      { title: '是否显示', name: 'labelVisible', type: 'switch' },
      { title: '标签类别', name: 'labelType', type: 'select', options: labelTypeOpts },
      {
        title: '偏移距离',
        name: 'labelOffset',
        type: 'number',
        visible: ({ labelVisible }) => labelVisible
      },
      {
        title: '文本颜色',
        name: 'labelColor',
        type: 'color',
        visible: ({ labelVisible }) => labelVisible === true
      }
    ]
  }
]

export function calcLabelData(options) {
  console.log('options', JSON.stringify(options))
  let calcData = {}
  if (options.labelVisible) {
    calcData = {
      type: options.labelType,
      offset: options.labelOffset,
      style: {
        fill: options.labelColor,
        textAlign: 'center'
      }
    }
  } else {
    calcData = false
  }
  console.log('calcData', calcData)
  return calcData
}
